
import { httpsCallable } from "firebase/functions";
import { functions } from "../config/firebaseConfig";

// Use the exact name of your deployed Firebase callable function
const createCheckoutSessionFn = httpsCallable(functions, "createCheckoutSession");

export async function createCheckoutSession(
  itemTitle: string,
  amount: number,
  email: string,
  reportId: string,
  userId: string,
  userName: string,
  relatedPersonId?: string,
  
): Promise<{ url?: string; free?: boolean }> {
  try {
    console.log({ itemTitle, amount, email, reportId, userId,relatedPersonId  })
    const result = await createCheckoutSessionFn({ itemTitle, amount, email, reportId, userId, userName, relatedPersonId,  });

    const sessionData = result.data as any;

    // ⭐ Support free reports
    if (sessionData.free) {
      return { free: true };
    }
    
    // ⭐ Normal Stripe redirect
    if (sessionData.url) {
      return { url: sessionData.url };
    }
    
    throw new Error("Invalid response from createCheckoutSession");
    
  } catch (err: any) {
    console.error("Error creating checkout session:", err);
    if (err.code && err.message) {
      // Rethrow structured Firebase HttpsError
      throw {
        code: err.code,
        message: err.message,
        details: err.details || null,
      };
    }

    // fallback: plain JS error
    throw new Error(err.message || "Unknown checkout session error");
  }
}


